<template>
  <div>
    <div ref="modelCourseTop" class="absolute target-top"></div>
    <div v-if="isCourse()">
      <div class="text-center mb-2 font-bold">{{ course.title }}</div>
      <div class="modal-content">
        <div class="modal-detail">
          <img v-lazy="course.images !== undefined ? course.images[0] : ''" class="course-image" />
          <p class="mt-2 mb-6 leading-tight" v-html="course.detail"></p>
        </div>
      </div>
    </div>
    <div v-if="isPlace()">
      <div class="text-center mb-2 font-bold">{{ place.name }}</div>
      <div class="modal-content">
        <div class="modal-detail">
          <img v-lazy="place.images !== undefined ? place.images[0] : ''" class="course-image" />
          <p class="mt-2 mb-6 leading-tight" v-html="place.detail"></p>
        </div>
      </div>
    </div>
    <div class="mb-4">
      <div class="mb-4">
        <p class="condition-label text-label">出発地と到着地が</p>
        <div class="absolute w-4 mt-4 right-6 flex z-10 text-gray-400">
          <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
            <path d="M24,37L0,13.1h48L24,37z"/>
          </svg>
        </div>
        <select v-model="sameStation" class="is-condition">
          <option value="true">同じ</option>
          <option value="false">異なる</option>
        </select>
      </div>
      <div class="condition-label text-label">
        <span v-if="sameStation === 'true'">
          {{ $t('tour_setting_station_label') }}
        </span>
        <span v-else>
          {{ $t('tour_setting_departure_label') }}
        </span>
      </div>
      <div class="absolute right-6 mt-4 flex items-center focus:outline-none z-10" @click="clearFromForm">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>
      </div>
      <input id="searchDepartureStation" @input="updateFromText($event.target.value)" class="input-station" :placeholder="$t('tour_require_station')" v-model="fromTextbox" />
      <div v-if="inputType === 'departure' && stations.length > 0 && fromName.length > 0">
        <div
          v-for="(station, index) in stations"
          v-bind:key="index"
          v-on:click="setFromStation(station)"
          class="station-name">
          {{ station.Name }}
        </div>
      </div>
      <div v-show="isStationDepartureInputError && sameStation === 'true'" class="text-sm text-red">発着地を設定してください</div>
      <div v-show="isStationDepartureInputError && sameStation === 'false'" class="text-sm text-red">出発地を設定してください</div>
    </div>
    <div v-show="sameStation === 'false'" class="mb-4">
      <div class="condition-label text-label">{{ $t('tour_setting_arrival_label') }}</div>
      <div class="absolute right-6 mt-4 flex items-center focus:outline-none z-10" @click="clearToForm">
        <svg xmlns="http://www.w3.org/2000/svg" height="24px" viewBox="0 0 24 24" width="24px" fill="#000000"><path d="M0 0h24v24H0V0z" fill="none"/><path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12 19 6.41z"/></svg>
      </div>
      <input id="searchArrivalStation" @input="updateToText($event.target.value)" class="input-station" :placeholder="$t('tour_require_station')" v-model="toTextbox" />
      <div v-if="inputType === 'arrival' && stations.length > 0 && toName.length > 0">
        <div
          v-for="(station, index) in stations"
          v-bind:key="index"
          v-on:click="setToStation(station)"
          class="station-name">
          {{ station.Name }}
        </div>
      </div>
      <div v-show="isStationArrivalInputError" class="text-sm text-red">到着地を設定してください</div>
    </div>

    <departure-datetime-select v-model="datetime" class="mb-4" />
    <div class="mb-4">
      <p class="condition-label text-label">移動方法</p>
      <div class="absolute w-4 mt-4 right-6 flex z-10 text-gray-400">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
          <path d="M24,37L0,13.1h48L24,37z"/>
        </svg>
      </div>
      <select v-model="mode" class="is-condition">
        <option v-for="(option, key) in modeOptions" v-bind:value="option.value" v-bind:key="key">
          {{ option.text }}
        </option>
      </select>
    </div>
    <div class="mb-4" v-if="mode === 'public'">
      <p class="condition-label text-label">{{ $t('tour_preferred_route_condition') }}</p>
      <div class="absolute w-4 mt-4 right-6 flex z-10 text-gray-400">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
          <path d="M24,37L0,13.1h48L24,37z"/>
        </svg>
      </div>
      <select v-model="sort" class="is-condition">
        <option v-for="(option, key) in sortOptions" v-bind:value="option.value" v-bind:key="key">
          {{ option.text }}
        </option>
      </select>
    </div>
    <div class="mb-4" v-if="mode === 'public'">
      <p class="condition-label text-label">{{ $t('tour_taxi_condition') }}</p>
      <div class="absolute w-4 mt-4 right-6 flex z-10 text-gray-400">
        <svg version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px" viewBox="0 0 48 48" style="enable-background:new 0 0 48 48;" xml:space="preserve">
          <path d="M24,37L0,13.1h48L24,37z"/>
        </svg>
      </div>
      <select v-model="taxiDistance" class="is-condition">
        <option v-for="(option, key) in taxiOptions" v-bind:value="option.value" v-bind:key="key">
          {{ option.text }}
        </option>
      </select>
    </div>
    <div class="modal-button">
      <a class="button-primary block button-icon icon-left" @click="searchPlan()">
        <svg height="12" viewBox="0 0 12 12" width="12" xmlns="http://www.w3.org/2000/svg" class="text-white"><path d="m734.333333 280.666667v2.666666h-2.666666c-.36819 0-.666667.298477-.666667.666667s.298477.666667.666667.666667h2.666666v2.666666c0 .36819.298477.666667.666667.666667s.666667-.298477.666667-.666667v-2.666666h2.666666c.36819 0 .666667-.298477.666667-.666667s-.298477-.666667-.666667-.666667h-2.666666v-2.666666c0-.36819-.298477-.666667-.666667-.666667s-.666667.298477-.666667.666667" transform="translate(-729 -278)"/></svg>
        <span>{{ $t('tour_create_plan_label') }}</span>
      </a>
    </div>
    <div class="mt-4">
      <a class="button-secondary block button-icon icon-left" @click="back">
        <svg height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg"><path d="m10 3.20710678v6.29289322c0 .27614237-.22385763.5-.5.5h-6.29289322c-.27614237 0-.5-.22385763-.5-.5 0-.13260824.05267842-.2597852.14644661-.35355339l6.29289322-6.29289322c.19526215-.19526215.51184463-.19526215.70710678 0 .09376819.09376819.14644661.22094515.14644661.35355339z" fill-rule="evenodd" transform="matrix(-.70710678 -.70710678 -.70710678 .70710678 16.485281 10)"/></svg>
        <span>{{ $t('tour_back_to_plan_top_label') }}</span>
      </a>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import _ from 'lodash'
import DepartureDatetimeSelect from './DepatureDatetimeSelect'
import Constants from '../../constants'
import moment from 'moment-timezone'
moment.tz.setDefault('Asia/Tokyo')

export default {
  name: 'NewPlanInput',
  components: {
    DepartureDatetimeSelect
  },
  props: {
    course: {
      type: Object,
      default: function () {
        return {
          id: null,
          title: null,
          detail: null,
          image: null,
          mode: null
        }
      }
    },
    place: {
      type: Object,
      default: function () {
        return {
          id: null,
          title: null,
          detail: null,
          image: null,
          mode: null
        }
      }
    },
    search: {
      type: Function,
      default: function () {
        return {}
      }
    },
    closeModal: {
      type: Function,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      inputType: null,
      fromTextbox: '',
      fromName: "",
      from: {},
      fromOldInput: "",
      toTextbox: '',
      toName: "",
      to: {},
      toOldInput: "",
      isStationDepartureInputError: false,
      isStationArrivalInputError: false,
      modeOptions: [
        { text: "公共交通", value: "public" },
        { text: "自動車", value: "car" },
        { text: "徒歩のみ", value: "walk" }
      ],
      taxiOptions: [
        { text: this.$t('tour_taxi_distance_none'), value: 0 },
        { text: this.$t('tour_taxi_distance_1km'), value: 1000 },
        { text: this.$t('tour_taxi_distance_3km'), value: 3000 }
      ],
      sortOptions: [
        { text: "早さ優先", value: "ekispert" },
        { text: "安さ優先", value: "price" },
        { text: "乗換回数少なさ優先", value: "transfer" }
      ],
      sameStation: 'true'
    }
  },
  created: function () {
    const value = moment().add(1, 'days').set('hour', 10).set('minute', 0)
    this.$store.dispatch('condition/updateTime', value)
    setInterval(() => {
      if (this.fromOldInput !== this.fromName && this.fromName.length > 0) {
        this.inputType = 'departure'
        this.from = {}
        this.isStationDepartureInputError = false
        this.fromOldInput = this.fromName
        this.$store.dispatch('stations/search', this.fromName)
      } else if (this.toOldInput !== this.toName && this.toName.length > 0) {
        this.inputType = 'arrival'
        this.to = {}
        this.isStationArrivalInputError = false
        this.toOldInput = this.toName
        this.$store.dispatch('stations/search', this.toName)
      }
    }, 300)
  },
  computed: {
    datetime: {
      get () {
        return this.$store.getters['condition/getTime']
      },
      set (value) {
        this.$store.dispatch('condition/updateTime', value)
      }
    },
    mode: {
      get () {
        return this.$store.getters['condition/getMode']
      },
      set (value) {
        this.$store.dispatch('condition/updateOptions', { mode: value })
      }
    },
    taxiDistance: {
      get () {
        return this.$store.getters['condition/getTaxiDistance']
      },
      set (value) {
        this.$store.dispatch('condition/updateOptions', { taxiDistance: value })
      }
    },
    sort: {
      get () {
        return this.$store.getters['condition/getSort']
      },
      set (value) {
        this.$store.dispatch('condition/updateOptions', { sort: value })
      }
    },
    ...mapGetters({
      stations: 'stations/getStations'
    })
  },
  methods: {
    setFromStation: function (station) {
      this.from = station
      this.fromTextbox = station.Name
      this.oldInput = this.name
      this.$store.dispatch('stations/reset')
    },
    setToStation: function (station) {
      this.to = station
      this.toTextbox = station.Name
      this.oldInput = this.name
      this.$store.dispatch('stations/reset')
    },
    updateFromText: function (name) {
      this.fromName = name
    },
    updateToText: function (name) {
      this.toName = name
    },
    isCourse: function () {
      return !_.isEmpty(this.course)
    },
    isPlace: function () {
      return !_.isEmpty(this.place)
    },
    searchPlan: function () {
      if (!_.isEmpty(this.from) && (this.sameStation === 'true' || !_.isEmpty(this.to))) {
        this.$store.dispatch('destinations/updateDepartureStation', this.from.Name)
        this.$store.dispatch('destinations/updateDepartureStationCode', this.from.code)
        if (this.sameStation === 'true') {
          this.$store.dispatch('destinations/updateArrivalStation', this.from.Name)
          this.$store.dispatch('destinations/updateArrivalStationCode', this.from.code)
        } else {
          this.$store.dispatch('destinations/updateArrivalStation', this.to.Name)
          this.$store.dispatch('destinations/updateArrivalStationCode', this.to.code)
        }
        this.$emit('search')
      } else {
        if (_.isEmpty(this.from)) {
          this.isStationDepartureInputError = true
        }
        if (_.isEmpty(this.to)) {
          this.isStationArrivalInputError = true
        }
        this.$refs['modelCourseTop'].scrollIntoView({ behavior: 'smooth'})
      }
    },
    clearFromForm: function () {
      this.from = {}
      this.fromTextbox = ''
    },
    clearToForm: function () {
      this.to = {}
      this.toTextbox = ''
    },
    back: function () {
      const areaId = this.$store.getters['user/getAreaId']
      if (areaId == Constants.DEFAULT_AREA_ID){
        this.$router.push({ name: 'plansTop', params: { lang: this.$store.getters['user/getLang'] } })
      }else{
        this.$router.push({ name: 'plansTop', params: { lang: this.$store.getters['user/getLang'], areaId: areaId } })
      }
    }
  },
  watch: {
    course: function () {
      this.from = {
        code: this.course.departure_code,
        Name: this.course.departure
      }
      this.to = {
        code: this.course.arrival_code,
        Name: this.course.arrival
      }
      if (this.course.departure_code !== this.course.arrival_code) {
        this.sameStation = 'false'
      }
      this.fromTextbox = this.course.departure
      this.toTextbox = this.course.arrival
      this.oldInput = this.name
      if (this.course.mode) {
        this.$store.dispatch('condition/updateOptions', { mode: this.course.mode })
      } else {
        this.$store.dispatch('condition/updateOptions', { mode: 'public' })
      }
      this.$store.dispatch('stations/reset')
    }
  }
}
</script>
